import { computed, Ref, ref } from 'vue';

import { useMediaQuery } from '../composables/media-query.composable';

import { CollapsibleHeight } from '../models/entities/information-card.model';
import { HiddenTitleStyles } from '../models/entities/location-box.model';

import { Icon } from '../models/utilities/icon.enum';

import { CALENDAR_TYPE } from '../models/constants';

export const useUtils = (collapsible?: Ref) => {
  const collapsed = ref(true);
  const collapsibleHeight = ref(0);
  const collapsibleMobileRowHeight = ref(0);

  // template refs
  const infoCardMiddleRow = ref();
  const infoCardBottomRow = ref();
  const infoCardMobileBottomRow = ref();

  const collapsibleStyle = computed((): CollapsibleHeight => {
    return collapsible && collapsible.value
      ? { maxHeight: collapsibleHeight.value + 'px' }
      : {};
  });

  const collapsibleMobileRowStyle = computed((): CollapsibleHeight => {
    return collapsible && collapsible.value
      ? { maxHeight: collapsibleMobileRowHeight.value + 'px' }
      : {};
  });

  const collapsibleButtonIconName = computed((): string => {
    return collapsed.value ? 'chevron-down' : 'chevron-up';
  });

  const icon = computed((): typeof Icon => {
    return Icon;
  });

  // ----------------------------#region-----------------------------
  // ---------------------HELPER RELATED COMPUTED METHODS----------
  // ----------------------------------------------------------------
  const { isMobile } = useMediaQuery();
  const toggleCollapsedState = (state?: boolean) => {
    collapsed.value = state || !collapsed.value;
  };

  const setCollapsibleHeight = () => {
    collapsibleHeight.value =
      (infoCardMiddleRow.value as HTMLElement)?.offsetHeight +
      ((infoCardBottomRow.value as HTMLElement)?.offsetHeight ?? 0);
    if (isMobile.value) {
      collapsibleMobileRowHeight.value = (
        infoCardMobileBottomRow.value as HTMLElement
      )?.clientHeight;
    }
  };

  const hiddenTitleStyles = (hideTitle: boolean): HiddenTitleStyles => {
    return hideTitle ? { maxHeight: '0px' } : {};
  };

  const calendarType = computed(() => {
    return isMobile.value ? CALENDAR_TYPE.MODAL : CALENDAR_TYPE.NORMAL;
  });

  return {
    // refs
    collapsed,
    collapsibleHeight,
    collapsibleMobileRowHeight,
    // template refs
    infoCardMiddleRow,
    infoCardBottomRow,
    infoCardMobileBottomRow,
    // computed
    calendarType,
    collapsibleStyle,
    collapsibleMobileRowStyle,
    collapsibleButtonIconName,
    icon,
    isMobile,
    // methods
    toggleCollapsedState,
    setCollapsibleHeight,
    hiddenTitleStyles,
  };
};
